import { useEffect, useState } from "react";
import api from "@/lib/api";
import { DollarSign } from "lucide-react";

export default function AffiliateEarnings() {
  const [rows, setRows] = useState([]);

  useEffect(() => { api.get("/affiliate/conversions").then((r) => setRows(r.data)); }, []);

  const total = rows.reduce((a, r) => a + (r.commission_amount || 0), 0);

  return (
    <div data-testid="affiliate-earnings">
      <div className="pf-chip pf-chip-cyan"><DollarSign className="w-3 h-3" /> Commissions</div>
      <h2 className="font-display text-3xl md:text-4xl font-medium tracking-tight mt-3 text-slate-900">Commission ledger</h2>
      <p className="text-sm text-slate-600 mt-1">
        Every attributed order and the commission it accrues. Total lifetime earnings: <span className="font-semibold text-cyan-700">${total.toFixed(2)}</span>
      </p>

      <div className="pf-card overflow-hidden mt-6">
        <table className="w-full text-sm">
          <thead className="bg-white/60 text-left text-xs uppercase tracking-widest text-slate-500">
            <tr>
              <th className="px-5 py-3">When</th>
              <th className="px-5 py-3">Campaign</th>
              <th className="px-5 py-3">Coupon</th>
              <th className="px-5 py-3">Revenue</th>
              <th className="px-5 py-3">Rate</th>
              <th className="px-5 py-3">Commission</th>
              <th className="px-5 py-3">Status</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.id} className="border-t border-white/60" data-testid={`aff-conv-${r.id}`}>
                <td className="px-5 py-3 text-xs text-slate-500">{new Date(r.accrued_at).toLocaleString()}</td>
                <td className="px-5 py-3 font-medium">{r.campaign_name}</td>
                <td className="px-5 py-3 font-mono text-xs">{r.coupon_code}</td>
                <td className="px-5 py-3 tabular-nums">${r.revenue.toFixed(2)}</td>
                <td className="px-5 py-3 text-xs">{r.commission_type === "percent" ? `${r.commission_value}%` : r.commission_type === "flat" ? `$${r.commission_value}` : "Tiered"}</td>
                <td className="px-5 py-3 tabular-nums font-semibold text-cyan-700">${r.commission_amount.toFixed(2)}</td>
                <td className="px-5 py-3"><span className={`pf-chip ${r.status === "paid" ? "pf-chip-mint" : r.status === "void" ? "" : ""}`}>{r.status}</span></td>
              </tr>
            ))}
            {rows.length === 0 && <tr><td colSpan={7} className="px-5 py-12 text-center text-slate-500">No conversions yet — share your tracking links.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
